module.exports = __webpack_public_path__ + "img/chart-line-area-multi.63895f39.svg";